export var fontSize01 = 12;
export var fontSize02 = 14;
export var fontSize03 = 16;
export var fontSize04 = 20;
export var fontSize05 = 32;